import '../css/common/common.css';
import '../css/common/content-wrapper.css';
import '../css/common/banner-wrapper.css';
import '../css/common/pattern-cover.css';
import '../css/common/section-block.css';
import '../css/common/button-effect.css';
import '../css/common/tab-list.css';

import '../css/nest-menu.css';
import '../css/card-block.css';

import '../js/importCommonCss';
import setup from './setupCommonJS';
import { ARTICLE_NUMBER_PER_PAGE, uploadUri } from './appConfig';
import languageBasedTag from './languageBasedTag';
import getScheduleList from './request/scheduleList';
import generateLinkCard from './transportation/generateLinkCard';
import itemStartFrom from './about/itemStartFrom';
import { currentPage, addPaginationButtons } from './pagination';
import hideLoadingImage from './common/hideLoadingImage';

setup();

document.head.appendChild(
	languageBasedTag(),
);

getScheduleList(
	itemStartFrom(
		currentPage,
		ARTICLE_NUMBER_PER_PAGE,
	),
).then((json) => {
	json.schedules.forEach((schedule) => {
		document.querySelector('.section-block > .content').appendChild(
			generateLinkCard(schedule.id, schedule.title, `${uploadUri}/${schedule.thumb} `),
		);
	});
	addPaginationButtons(json.total, ARTICLE_NUMBER_PER_PAGE);
})
	.then(() => {
		hideLoadingImage();
	});



// WEBPACK FOOTER //
// ./src/js/schedules.js